import axios from 'axios';
import { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';

interface StateItem {
  id: number;
  name: string;
  code2: string;
  allowed: boolean;
}

const CountryList = () => {
  const [countrys, setStates] = useState<StateItem[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');

  const fetchStates = async () => {
    try {
      const response = await axios.get('https://api.trubetx.com/admin/getcountryList');
      if (response.data) {
        setStates(response.data.data);
      } else {
        toast.error('Failed to fetch countrys.');
      }
    } catch (error) {
      console.error('Error fetching countrys:', error);
      toast.error('Error fetching countrys.');
    }
  };

  useEffect(() => {
    fetchStates();
  }, []);

  const toggleAllowed = async (state: StateItem) => {
    try {
      const updatedState = { ...state, allowed: !state.allowed };
      const response = await axios.post(
        `https://api.trubetx.com/admin/updateCountry/${state.id}`,
        updatedState
      );

      if (response.data.status) {
        toast.success('Country updated successfully!');
        setStates((prev) =>
          prev.map((s) => (s.id === state.id ? { ...s, allowed: !s.allowed } : s))
        );
      } else {
        toast.error('Failed to update state.');
      }
    } catch (error) {
      console.error('Error updating state:', error);
      toast.error('Error updating state.');
    }
  };

  const filteredCountries = countrys.filter(
    (country) =>
      country?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      country?.code2?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="ml-0 lg:ml-[256px] p-4">
      <h2 className="text-2xl font-semibold mb-4 text-black">Country Management</h2>
      <hr className="p-5" />

      {/* 🔍 Search Input */}
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search by country name or code"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full lg:w-1/3 px-4 py-2 border rounded text-black"
        />
      </div>

      {/* 🌍 Display Countries */}
      <div>
        {filteredCountries.length > 0 ? (
          <table className="table-auto w-full text-black text-center">
            <thead>
              <tr>
                <th className="border px-4 py-2">S.No.</th>
                <th className="border px-4 py-2">Country Name</th>
                <th className="border px-4 py-2">Country Code</th>
                <th className="border px-4 py-2">Allowed</th>
              </tr>
            </thead>
            <tbody>
              {filteredCountries.map((state, index) => (
                <tr key={state.id}>
                  <td className="border px-4 py-2">{index + 1}</td>
                  <td className="border px-4 py-2">{state.name}</td>
                  <td className="border px-4 py-2">{state.code2}</td>
                  <td className="border px-4 py-2">
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={state.allowed}
                        onChange={() => toggleAllowed(state)}
                        className="sr-only peer"
                      />
                      <div
                        className={`w-11 h-6 rounded-full relative transition-all ${
                          state.allowed ? 'bg-green-500' : 'bg-red-500'
                        }`}
                      >
                        <div
                          className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full transition-all ${
                            state.allowed ? 'translate-x-5' : ''
                          }`}
                        ></div>
                      </div>
                    </label>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-black">No countries match your search.</p>
        )}
      </div>

      <ToastContainer />
    </div>
  );
};

export default CountryList;
